var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28645",
    "data-name": "Group 28645",
    transform: "translate(3570 2604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28642",
    "data-name": "Group 28642",
    transform: "translate(50.374 -1325.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47097",
    "data-name": "Path 47097",
    d: "M-3610.609-1270.892v-1.012h1.252v1h7.521v-1h1.259v1c.063,0,.114.007.164.007h1.542a2.1,2.1,0,0,1,2.058,2.048q0,2.028,0,4.057c0,.047,0,.093-.007.154H-3613.1c0,.051-.01.089-.01.126q0,3.841,0,7.683a.834.834,0,0,0,.855.931,3.091,3.091,0,0,0,.313.023c.9,0,1.8-.014,2.7-.013q1.855,0,3.71.015a.574.574,0,0,1,.6.561.618.618,0,0,1-.447.678.892.892,0,0,1-.182.013c-2.274,0-4.548,0-6.821,0a1.941,1.941,0,0,1-1.461-.707,2.053,2.053,0,0,1-.537-1.442q.008-6.032,0-12.065a2.154,2.154,0,0,1,2.042-2.06c.522.014,1.045,0,1.568,0Zm1.252,1.261v1.86h-1.254v-1.861c-.044,0-.074-.006-.1-.006-.483,0-.967,0-1.45,0a.909.909,0,0,0-.948.958q0,1.311,0,2.622c0,.173,0,.173.179.173h14.673c.059,0,.118-.005.179-.008a.485.485,0,0,0,.01-.062c0-.931.01-1.861,0-2.791a.889.889,0,0,0-.931-.892c-.479,0-.958,0-1.437,0-.042,0-.083,0-.14.008v1.859h-1.252v-1.86Z",
    transform: "translate(-0.001)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47098",
    "data-name": "Path 47098",
    d: "M-2122.193-6.676a4.928,4.928,0,0,1-4.651,4.94,4.956,4.956,0,0,1-5.1-4.651,4.952,4.952,0,0,1,4.658-5.117A4.908,4.908,0,0,1-2122.193-6.676Zm-1.229.1a3.653,3.653,0,0,0-3.609-3.691,3.653,3.653,0,0,0-3.683,3.649,3.655,3.655,0,0,0,3.7,3.644A3.636,3.636,0,0,0-2123.422-6.578Z",
    transform: "translate(-1472.185 -1251.65)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47099",
    "data-name": "Path 47099",
    d: "M-3144.075,85.047v1.2h-4.246v-1.2Z",
    transform: "translate(-462.891 -1347.794)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47100",
    "data-name": "Path 47100",
    d: "M-3150.346,640.958h4.244v1.207c-.042,0-.086.008-.13.008-1.327,0-2.654,0-3.981,0-.11,0-.145-.027-.143-.141.008-.321,0-.642,0-.963C-3150.354,641.037-3150.349,641-3150.346,640.958Z",
    transform: "translate(-460.87 -1899.954)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47101",
    "data-name": "Path 47101",
    d: "M-1481.067,362.986h1.2c0,.059.007.112.007.166,0,.507,0,1.014,0,1.522,0,.106.031.136.136.135.511,0,1.023,0,1.534,0h.148v1.211c-.047,0-.1.007-.145.007h-2.764c-.073,0-.129,0-.129-.1,0-.959,0-1.919,0-2.878A.4.4,0,0,1-1481.067,362.986Z",
    transform: "translate(-2118.78 -1623.821)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.45
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestAccounts);
export default __webpack_public_path__ + "static/media/Test_Accounts.2e1dc583.svg";
export { ForwardRef as ReactComponent };